import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  Form,
  CardBody,
  CardHeader,
  Container,
} from "reactstrap";
import Dropzone from "react-dropzone";

// Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Link } from "react-router-dom";
import axios from "axios";
import config from "../../config";
const FormUpload = () => {
  //meta title
  // document.title = "Form File Upload | Zayon";

  const token = localStorage.getItem('authUser');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [message, setMessage] = useState('');
  const [proccess, setProccess] = useState('default');
  const [loading, setLoading] = useState(false);

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setSelectedFiles(files);
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const handleSubmit = () => {
    setLoading(true);
    setMessage('Processando...');

    const formData = new FormData();
    selectedFiles.forEach(file => {
      formData.append(file.name, file);
    });


    axios.post(`${config.apiUrl}/api/upload/`, formData, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      }
    })
      .then(response => {
        if (response.status === 201) {
          setSelectedFiles([]);
          // setProccess('success')
          // setMessage('Arquivo enviado com sucesso.');

          axios.post(`${config.apiUrl}/api/analise/`, {}, {
            headers: {
              "Authorization": `Bearer ${token}`,
            }
          })
            .then(analiseResponse => {
              if (analiseResponse.status === 201) {
                setMessage('Análise iniciada com sucesso.');
                setProccess('success')
                location.href = "/compliance"
              }
            })
            .catch(error => {
              setMessage(`Erro durante a solicitação de análise, tente novamente em instantes.`);
              setProccess('error')
            })
            .finally(() => {
              setLoading(false);
              // setProccess(false)
            });
        }
      })
      .catch(error => {
        setMessage(`Erro durante o upload do arquivo, verifique se está importando os arquivos necessários.`);
        setProccess('error')
        setLoading(false);
      });
  };

  const handleRemoveFile = (index) => {
    setSelectedFiles(selectedFiles.filter((_, i) => i !== index));
  };
  
  return (
    <React.Fragment>
      <div>
        <Container fluid={true}>
          {/* <Breadcrumbs title="Dashboard" breadcrumbItem="Upload" /> */}

          <Row>
            <Col className="col-12">
              <Card>
                <CardHeader>
                  <h4 className="card-title">Análise</h4>
                  <p className="card-title-desc">
                    Para iniciar a análise, você precisa fazer o upload dos
                    arquivos necessários. Utilize o campo abaixo para iniciar.
                  </p>
                </CardHeader>
                <CardBody>
                  {message && <div className={`alert ${proccess == 'success' ? 'alert-success' : proccess == 'error' ? 'alert-danger' : 'alert-info'} `}>{message}</div>}
                  <Form style={{ cursor: "pointer" }}>
                    <Dropzone
                      onDrop={(acceptedFiles) => {
                        handleAcceptedFiles(acceptedFiles);
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone">
                          <div
                            className="dz-message needsclick mt-2"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            <div className="mb-3">
                              <i className="display-4 text-muted bx bx-cloud-upload" />
                            </div>
                            <h4>
                              Clique para fazer o upload ou arraste os arquivos aqui...
                            </h4>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <div className="dropzone-previews mt-3" id="file-previews">
                      {selectedFiles.map((file, i) => (
                        <Card
                          className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                          key={i + "-file"}
                        >
                          <div className="p-2">
                            <Row className="align-items-center">
                              <Col className="col-auto">
                                <img
                                  data-dz-thumbnail=""
                                  height="80"
                                  className="avatar-sm rounded bg-light"
                                  alt={file.name}
                                  src={file.preview}
                                />
                              </Col>
                              <Col>
                                <Link to="#" className="text-muted font-weight-bold">
                                  {file.name}
                                </Link>
                                <p className="mb-0">
                                  <strong>{file.formattedSize}</strong>
                                </p>
                              </Col>
                              <Col className="col-auto">
                                <button
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    handleRemoveFile(i)
                                  }}
                                >
                                  <i className="fa fa-times"></i>
                                </button>
                              </Col>
                            </Row>
                          </div>
                        </Card>
                      ))}
                    </div>
                  </Form>
                  <div className="text-center mt-4">
                    <button
                      type="button"
                      onClick={handleSubmit}
                      className="btn btn-primaryOpacity border-0"
                      disabled={loading}
                    >
                      {loading ? 'Processando...' : 'Fazer análise'}
                    </button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FormUpload;
